export default {
	asideSelector: '.js-catalog-aside',
	asideInnerSelector: '.js-catalog-aside-inner',
	asideWrapperSelector: '.js-catalog-aside-wrapper',
	paginationSelector: '.js-catalog-pagination',
	toggleButtonSelector: '.js-catalog-filter-toggle',
	asideHiddenContentSelector: '.js-catalog-hidden-content',
	asideHiddenToggleButtonSelector: '.js-catalog-toggle-trigger',
	showResultButtonSelector: '.js-catalog-filter-show-results',
	scrollbarNeedUpdateEventName: 'catalog-filter-scrollbar-need-update'
}
